import axios from 'axios';
import vm from '@/main';
import {clearLoginInfo} from "@/utils/index";

const service = axios.create({
  baseURL: process.env.VUE_APP_API || location.origin, // api 的 base_url
  withCredentials: true,
  timeout: 30000 // request timeout
});
let handlingUnauthorized = false;
function clearAndJumpLogin(){
  if(handlingUnauthorized || (vm.$route.name === 'login' && !localStorage.getItem('token'))) return;
  handlingUnauthorized = true;
  clearLoginInfo(vm.$router);

  //为了修复  修改密码弹框跳转到登录页无法自动关闭的问题
  // 获取所有具有指定类名的元素
  var elements = document.querySelectorAll('.active-prompt');

  // 遍历这些元素并移除它们
  elements.forEach(function(element) {
      element.parentNode.removeChild(element);
  });

  const finish = () => {
    handlingUnauthorized = false;
  };
  if(vm.$route.name === 'login'){
    finish();
    return;
  }
  vm.$router.push({
    name: 'login',
  }, finish, error => {
    finish();
    // eslint-disable-next-line no-console
    if(error && error.name !== 'NavigationDuplicated') console.error(error);
  });
}

// request interceptor
service.interceptors.request.use(
  config => {
    config.data = JSON.stringify(config.data);

    config.headers = {
      "Content-Type": 'application/json;charset=UTF-8',
    };
    if(config.url.indexOf('oss/upload') !== -1){
      config.data = config.data;
      config.headers["Content-Type"] = 'multipart/form-data';
    }
    let tokenX = localStorage.getItem('token');
    if(tokenX){
      config.headers['token'] = tokenX;
    }

    if(window.location.origin.indexOf('https') > -1 && config.baseURL.indexOf('https') == -1){
      config.baseURL = config.baseURL.replace('http','https');
    }
    return config;
  },
  error => {
    console.log('requestErr' + error); // for debug
    Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    // 上传图片500的时候没有弹出对应的消息 todo
    if (response.data && response.data.code === 401) { // 401, token失效
      clearAndJumpLogin();
    }
    let noCodeUrl = ['/wx/sys/menu/list','/wx/manage/wxAccount/list'];
    // 400 在公众号相关的读接口上表示"前置条件不满足、暂无数据"，静默返回让页面渲染空态即可，
    // 不弹全局提示（见 457a8ab）。但写请求的 400 是真实失败：若同样放行，
    // 调用方的 .then() 会把它当成功执行——弹"保存成功"、关弹窗、刷新列表，用户以为已保存。
    const isRead = String(response.config.method || 'get').toLowerCase() === 'get';
    const silent400 = response.data && response.data.code === 400 && isRead;
    if(!silent400 && !noCodeUrl.includes(response.config.url) && response.data && response.data.code !== 200 && response.data.code !== 401){
    //暂接口没有统一的返回
      vm.$vs.notify({
        title: '注意',
        text: response.data.msg,
        position: 'top-center',
        color: 'danger',
      });
      return Promise.reject(response.data);
    }
    return response.data;
  },
  error => {
    if(error.response && error.response.status === 401){
      clearAndJumpLogin();
    }else {
      vm.$vs.notify({
        title: '注意',
        text: '服务暂时不可用，请稍后重试',
        position: 'top-center',
        color: 'danger',
      });
    }

    return Promise.reject(error);
  }
);
export default service;
